<template>
	<div>
		<div class="contentBigBox" v-loading="loading">
			<div class="details-title">
				<div>{{ exportsListTitle.name }}报告列表</div>
				<div>
					<span v-if="exportsListTitle.categoryName != null">抽样类型: {{ exportsListTitle.categoryName }}</span>
				</div>
			</div>
			<el-tabs type="card" class="exportTab" v-model="activeName" v-if="statusTab" @tab-click="tabClick">
				<el-tab-pane :label="`待质控(${experts.sampling})`" name="123">待质控</el-tab-pane>
				<el-tab-pane :label="`进行中(${experts.complete})`" name="125">进行中</el-tab-pane>
				<el-tab-pane :label="`已完成(${experts.pending})`" name="130">已完成</el-tab-pane>
			</el-tabs>
			<el-table class="qcTable" :data="list" fixed="right" :row-class-name="tableRowClassName">
				<el-table-column prop="AccNo" min-width="100" label="报告编号"></el-table-column>
				<el-table-column prop="ModalityType" label="设备类型"></el-table-column>
				<el-table-column prop="CheckingItems" label="检查项目"></el-table-column>
				<el-table-column v-if="doctorTaskStatus > 123" prop="ImageScore" label="影像评分"></el-table-column>
				<el-table-column v-if="doctorTaskStatus > 123" prop="ReportScore" label="报告评分"></el-table-column>
				<el-table-column v-if="doctorTaskStatus > 123" prop="DiseaseHistoryScore" label="病史评分"></el-table-column>
				<el-table-column prop="Status" label="状态">
					<template slot-scope="scope">
						<div>
							<span>{{ scope.row.Status | formatStatus }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="操作" fixed="right" width="180">
					<template slot-scope="scope">
						<span class="tableOpe" @click="handleClick(scope.row)">{{ doctorTaskStatus > 125 || scope.row.TaskStatus == -1 ? '查看详情' : '去质控' }}</span>
						<span class="tableOpe marl10" v-if="scope.row.Status == 130" @click="withdrawl(scope.row)">撤回</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pages">
				<el-pagination
					class="pageAll"
					layout="prev, pager, next"
					:total="totalsecond"
					:page-size="listParameter.PageCount"
					:current-page="pageIndex.page"
					@current-change="currentChange"
				></el-pagination>
			</div>
		</div>
	</div>
</template>
<style scoped>
.contentBigBox {
	padding-top: 36px;
}
</style>
<script>
// import { mapState, mapActions, mapMutations} from 'vuex'
export default {
	data() {
		return {
			activeName: '123'
		};
	},
	computed: {
		...Vuex.mapState('breadcrumb', ['loading']),
		...Vuex.mapState('doctor', [
			'isSubmint',
			'statusTab',
			'list',
			'total',
			'listParameter',
			'totalsecond',
			'pageIndex',
			'exportsListTitle',
			'statusList',
			'experts',
			'doctorTaskStatus',
			'doctorTaskType'
		]),
		...Vuex.mapState('managerPlanList', ['qcresultsList'])
	},
	filters: {
		formatStatus: function(value) {
			return (
				{
					'': '不限',
					'120': '已抽样',
					'123': '已分配',
					'125': '进行中',
					'130': '已完成',
					'140': '申诉中',
					'170': '已归档'
				}[value] || '不限'
			);
		}
	},
	activated() {
		if (this.statusList == 10 || this.statusList == 15 || this.statusList == '15,20') {
			this.setIsSubmint(false);
			this.setisSubmintflag(false);
			this.exportDoctorStatus(123);
			this.activeName = '123';
		}
		if (this.statusList == 20) {
			this.setIsSubmint(false);
			this.setisSubmintflag(false);
			this.exportDoctorStatus(123);
			this.activeName = '123';
		}
		if (this.statusList == 50) {
			this.setIsSubmint(true);
			this.setisSubmintflag(true);
			this.exportDoctorStatus(130);
			this.activeName = '130';
		}
		this.currentChangesSecond(1);
		this.GetExpertTaskList();
	},
	methods: {
		...Vuex.mapMutations('doctor', [
			'setDetalLoading',
			'setLoading',
			'experListShowMu',
			'currentChangesSecond',
			'setSplitScreen',
			'setDetailsParameter',
			'setremark',
			'exportDoctorStatus',
			'setIsSubmint',
			'setisSubmintflag'
		]),
		...Vuex.mapActions('doctor', ['GetReportDetail', 'GetExpertTaskList', 'ReturnSamplingReport']),
		withdrawl(datas) {
			let _this = this;
			this.$confirm('确定撤回该报告吗？撤回后报告变为进行中。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.ReturnSamplingReport({
					SamplingTaskGuid: datas.SamplingTaskGuid,
					ReportGuid: datas.ReportGuid,
					ExpertUserGuid: datas.ExpertUserGuid
				}).then(res=>{
					_this.activeName = '125';
					_this.exportDoctorStatus(125);
					_this.GetExpertTaskList();
					_this.$message.success('撤回成功');
				});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消撤回'
				});
			});
		},
		//隔行换色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 != 0) {
				return 'warning-row';
			}
			return '';
		},
		handleClick(datas) {
			if (this.activeName > 125 || datas.TaskStatus == -1) {
				this.setIsSubmint(true);
				this.setisSubmintflag(true);
			} else {
				this.setIsSubmint(false);
				this.setisSubmintflag(false);
			}
			this.setDetailsParameter({
				reportGuid: datas.ReportGuid,
				samplingTaskGuid: datas.SamplingTaskGuid
			});
			this.qcresultsList.expertUserId = datas.ExpertUserGuids[0];
			this.qcresultsList.ReportGuid = datas.ReportGuid;
			this.qcresultsList.SamplingTaskGuid = datas.SamplingTaskGuid;
			this.setremark();
			// this.GetReportDetail();
			this.$router.push('/home/doctor/scoring');
		},
		//分页
		currentChange(val) {
			this.setLoading(true);
			this.currentChangesSecond(val);
			this.GetExpertTaskList();
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		tabClick(tab, event) {
			this.setLoading(true);
			this.exportDoctorStatus(tab.name);
			this.GetExpertTaskList();
		},
		array2Str: function(datas) {
			if (datas) {
				let str = '';
				for (let i = 0; i < datas.length; i++) {
					str += '<p>' + datas[i] + '</p>';
				}
				return str;
			}
		}
	}
};
</script>
